import React, { useState } from 'react'
import ClientDropdown from '../../../Checklist/Checklists/Forms/ClientDropdown';
import CobrandDropDown from '../../../Checklist/Checklists/Forms/CobrandDropDown';
import CobrandTagsDropdown from '../../../Checklist/Checklists/Forms/CobrandTagsDropdown';
import ClientsTable from '../../../Checklist/Checklists/OnOffSettings/OptionTables/ClientsTable';
import CobrandTable from '../../../Checklist/Checklists/OnOffSettings/OptionTables/CobrandTable';
import CobrandTagsTable from '../../../Checklist/Checklists/OnOffSettings/OptionTables/CobrandTagsTable';

const OptionsTable = ({ optionTable, setOptionTable }) => {
    switch (optionTable) {
      case "cobrandTag":
        return <CobrandTagsTable setOptionTable={setOptionTable} />;
      case "cobrand":
        return <CobrandTable setOptionTable={setOptionTable} />;
      case "client":
        return <ClientsTable setOptionTable={setOptionTable} />;
      default:
        return null;
    }
  };

  const SelectCobrandsForm = ({featured, width}) => {
    const [optionTable, setOptionTable] = useState();

      return(
          <div className="mt-1" style={{width:width ? width : 600}}>
              <ClientDropdown
              name="client"
              label="Clients"
              multiSelect
              setOptionTable={setOptionTable}
            />
            <CobrandTagsDropdown
              name="cobrandTag"
              label="Cobrand Tags"
              setOptionTable={setOptionTable}
              multiSelect
            />
            <CobrandDropDown
              name="cobrand"
              label="Cobrand"
              byNameOrId="id"
              setOptionTable={setOptionTable}
              multiSelect
              featured={featured}
            />
            <OptionsTable setOptionTable={setOptionTable} optionTable={optionTable} />
          </div>
      )
  }

  export default SelectCobrandsForm